'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".Content-module_content__dii8H{align-self:flex-start;grid-column:span 12}";
var styles = {"content":"Content-module_content__dii8H"};
styleInject["default"](css_248z, '0bbe2242-151e-4867-822e-0e96e93aed2d');

exports["default"] = styles;
